// extracted by mini-css-extract-plugin
export default {"successModal":"styles_successModal__KtDTB","title":"styles_title__HT69S","description":"styles_description__QuTIp","button":"styles_button__E-TDw"};